import React from 'react'
import { connect } from 'react-redux';

import {
  updateFinancialsStart,
} from '../../../actions'

import ActionButtons from '../../commons/ActionButtons'

class Financials extends React.Component {
  state = {
    creditSenseTerminated: false
  }

  componentDidMount() {
    let { creditSenseReport } = this.props;

    $.CreditSense.Iframe({
            client: gon.services.creditSense.storeCode, // This is your client code and how we identify your business
            elementSelector: "#creditSenseIFrame",
            debugBanks: gon.services.creditSense.debugBanks,
            params: {
              appRef: creditSenseReport.reference, // Set this value to a unique reference for the application
              uniqueAppRef: true,  // indicates that the appRef provided is unique
              cssOverride: gon.services.creditSense.stylesheet,
              // alreadyAgreedTerms: true, // NOTE: This can only be used if you have contacted Credit Sense for integrating our terms and conditions within your loan application terms and had this process approved.
              enableDynamicHeight: true,
              multibank: true, // indicates we expect there to be multiple bank accounts
            },
            callback: (response, data) => {
              switch (response) {
                case "97":
                  console.log('------> Account credentials submitted');
                  this.setState({creditSenseTerminated: false})
                  break;
                case "99": // Example status code (Bank status success)
                  console.log('------> BANK SUCCESS');
                  this.setState({creditSenseTerminated: true})
                  break;
                case "100": // Example status code
                  console.log('------> Application success - TERMINAL');
                  break;
                default:
                  break;
              }
            }
        });
  }

  renderIframe() {
    return(
      <iframe id="creditSenseIFrame" src="about:blank" style={ styles.iframe }>
        iframes are not supported in this browser
      </iframe>
    )
  }

  // skip credit sense. update credit sense report enable to false
  onSkipClick = () => {
    this.props.updateFinancialsStart({
      creditSenseTerminated: false
    })
  }

  onContinueClick = () =>  {
    let { creditSenseTerminated } = this.state;

    if (creditSenseTerminated) {
      this.props.updateFinancialsStart({
        creditSenseTerminated: true
      })
    }
  }

  continueEnabled() {
    return this.state.creditSenseTerminated
  }

  renderSkipCreditSenseLink() {
    if (this.props.creditSenseReport.enabled) {
      return(null)
    }
    return(
      <div className='link_underline' onClick={this.onSkipClick }>
        No thanks, I'll enter the details manually
      </div>
    )
  }

  render() {
    return(
      <div>
        <h3>Your financials</h3>
        <p>To approve your loan, we need some information on your income and expenses.</p>
        <p>
          We can automatically retrieve the information from your bank account through our secure partner, Credit Sense.
          This speeds up our credit decision process and will save you from having to manually send over your bank statements.
        </p>
        <div className="card card-single select-bank">
          <div className="card-body">
            { this.renderIframe() }
          </div>
        </div>

        { this.renderSkipCreditSenseLink() }

        <ActionButtons
          continueEnabled={ this.continueEnabled() }
          onContinueClick={ this.onContinueClick }
        />
      </div>
    )
  }
}

const styles = {
  iframe: {
    height: '580px',
    width: '98%',
    border: 'none',
  }
}

const mapStateToProps = (state) => ({
  creditSenseReport: state.creditSenseReport
});

export default connect(mapStateToProps, {
  updateFinancialsStart
})(Financials);
